import { Input } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';

type FactorInterpretationInfoProps = {
  value: string;
};

export const FactorInterpretationInfo = ({ value }: FactorInterpretationInfoProps) => {
  const { t } = useTranslation();

  return (
    <Input
      name='value'
      tooltipText={t('factors.valueWillBeUsed')}
      readonly
      label={t('common.calculationValue')}
      value={value}
    />
  );
};
